export const HEADER_COLS = [
  $localize`SUN`,
  $localize`MON`,
  $localize`TUE`,
  $localize`WED`,
  $localize`THUR`,
  $localize`FRI`,
  $localize`SAT`,
];

export const AVAILABLE_HEADER_COLS = [
  $localize`Status`.toUpperCase(),
  $localize`Start`.toUpperCase(),
  $localize`End`.toUpperCase(),
  $localize`EFFECTIVE DATE`,
];

export const CLOSED_HEADER_COLS = [
  $localize`Start Date`.toUpperCase(),
  $localize`End Date`.toUpperCase(),
];

export const LABEL_ROW = [
  $localize`Availability`.toUpperCase(),
  $localize`Closed`.toUpperCase(),
];
